import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { NotificationItem, NotificationVisualState } from '../../../core/models/notification-center.model';
import { NotificationItemComponent } from './notification-item.component';

@Component({
  selector: 'app-notification-panel',
  standalone: true,
  imports: [NotificationItemComponent],
  templateUrl: './notification-panel.component.html',
  styleUrl: './notification-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationPanelComponent {
  readonly open = input<boolean>(false);
  readonly notifications = input<readonly NotificationItem[]>([]);
  readonly unreadCount = input<number>(0);
  readonly state = input<NotificationVisualState>('loading');
  readonly errorMessage = input<string | null>(null);
  readonly loadingMore = input<boolean>(false);
  readonly hasMore = input<boolean>(false);

  readonly close = output<void>();
  readonly retry = output<void>();
  readonly selectNotification = output<NotificationItem>();
  readonly loadMore = output<void>();

  onClose(): void {
    this.close.emit();
  }

  onRetry(): void {
    this.retry.emit();
  }

  onSelect(notification: NotificationItem): void {
    this.selectNotification.emit(notification);
  }

  onScroll(event: Event): void {
    if (!this.hasMore() || this.loadingMore() || this.state() !== 'ready') {
      return;
    }

    const target = event.target as HTMLElement | null;
    if (!target) {
      return;
    }

    const thresholdPx = 48;
    const reachedBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - thresholdPx;
    if (reachedBottom) {
      this.loadMore.emit();
    }
  }
}

